export const extractDifferences = (customer, formFields, fieldMap) => {
  return Object.keys(fieldMap).reduce((obj, internal) => {
    const external = fieldMap[internal]
    const valueExternal = formFields[external]
    const valueInternal = customer[internal]
    if (valueInternal !== valueExternal) {
      obj[internal] = valueExternal
    }
    return obj
  }, {})
}
